{
    "generic": "Une erreur s'est produite. Veuillez réessayer.",
    "notFound": "Nous n'avons pas trouvé ce que vous cherchiez."
}
